import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import PageLoader from './PageLoader';
import { rememberPendingConnectorCallback } from '../lib/pendingConnectorCallback';

const ProtectedRoute: React.FC = () => {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return <PageLoader />;
  }

  if (!user) {
    // A service's consent page sent a signed-out browser back with a
    // one-time code: keep the address so sign-in resumes the connection
    // (AuthCallback). Every other route still lands on /auth as before.
    if (location.pathname === '/connectors/callback') {
      rememberPendingConnectorCallback(`${location.pathname}${location.search}`);
    }
    return <Navigate to="/auth" replace />;
  }

  if (!user.onboardingCompleted) {
    return <Navigate to="/onboarding" replace />;
  }


  return <Outlet />;
};

export default ProtectedRoute; 